/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type TopicFilterConfigColumn = (typeof TopicFilterConfigColumn)[keyof typeof TopicFilterConfigColumn];

export const TopicFilterConfigColumn = {
  topic: 'topic',
} as const;
